/**
 * Formats a date based on locale
 *
 * @example
 *   getFormattedDate("2023-09-25T02:00", "de-DE")   // 25.09.2023
 *
 * @param {string} value - The date to be formatted
 * @param {string} locale - The locale
 * @returns {string|null} - The date in the formatting of the locale or null if no string is found
 */
export const getFormattedDate = (value, locale) => {
  if (typeof value !== "string") return value
  const date = new Date(value)
  const options = { year: "numeric", month: "2-digit", day: "2-digit" }
  return date.toLocaleDateString(locale, options)
}

/**
 * Formats a date form YYYYMM to MM.YYYY
 *
 * @example
 *   getFormattedMonthYear("202409")   // 09.2023
 *
 * @param {string} value - The date to be formatted
 * @returns {string|null} - The formatted date or null
 */
export const getFormattedMonthYear = (value) => {
  if (!value || typeof value !== "string" || value.length !== 6) return value
  const year = value.slice(0, 4)
  const month = value.slice(4)
  return `${month}.${year}`
}

/**
 * Current calendar date as YYYY-MM-DD (for Sanity date string compare).
 *
 * @returns {string}
 */
export const getCurrentDate = () => {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Berlin",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date())
}
